export const Constants = {
	GOOGLE: 1,
	LEVELS: {
		ADMIN: 1,
		CLIENT: 2,
		DRIVER: 3,
		OWNER: 4,
		MODERATOR: 5,
	},
	MODERATOR_TYPE: {
		SUPERVISOR: 1,
		COORDINATOR: 2,
	},
	USER: {
		USER_VERIFIED: {
			VERIFIED: 1,
			NO_VERIFIED: 0
		},
		STATUS: {
			SERVICE_OFF: 0,
			SERVICE_ON: 1,
			DISABLED: 2
		}
	},
	NOTIFICATIONS: {
		STATUS: {
			READED: 1,
			UNREADED: 0
		}
	},
	DOCUMENTS_TYPE: {
		RIF: 1,
		CI: 2,
		DISCHARGE: 3,
		FOREIGN: 4 
	},
	VEHICLE_TYPE: {
		SEDAN: 1,
		VAN: 3,
		CAMIONETA: 2,
		OMNIBUS: 4
	},
	VEHICLE_TYPE_STATUS: {
		INACTIVE: 0,
		ACTIVE: 1,
	},
	BELONGS_TO: {
		MAXER: 1,
		OWNER: 2,
	},
	ORDER: {
		STATUS: {
			PENDING: 0, //PENDIENTE
			INIT: 1, //HA LLEGADO EL DRIVER
			IN_PROCESS: 2, //INICIAR VIAJE
			REJECTED: 3, //Rechazado
			FINISHED: 4, //Finalizado
			CANCELLED: 5, //Cancelado,
			ON_ROUTE: 6, // En ruta
			ACCEPTED: 7,
			ALERT_REJECTED: 8,
			ALERT_UNACCEPTED: 9,
			CONFIRMED: 10,
			ALERT_UNCONFIRMED: 11,
			INITIATED: 12,
			ALERT_UNINITIATED: 13,
		},
		LOCATION: {
			ORIGIN: 0,
			DESTINATION: 1,
			EXTRA: 2
		},
		SCHEDULED_TYPES: {
			IMMEDIATELY: 1,
			SCHEDULED: 2,
			FIXED: 3,
		}
	},
	ROUTE: {
		STATUS: {
			INACTIVE: 0,
			ACTIVE: 1,
		}
	},
	VEHICLE_STATUS: {
		INACTIVE: 0,
		ACTIVE: 1,
	},
	VEHICLE_FAILURE: {
		STATUS: {
			PENDING: 0,
			RESOLVED: 1
		}
	},
	MAINTENANCE: {
		INTERVAL_TYPE: {
			MILEAGE: 1,
			TIME: 2,
			BOTH: 3,
		},
		INTERVAL_UNIT: {
			DAY: 'DAY',
			WEEK: 'WEEK',
			MONTH: 'MONTH',
			YEAR: 'YEAR',
		},
		STATUS: {
			PENDING: 0,
			IN_PROCESS: 1,
			FINISHED: 2,
		}
	},
	BILLING: {
		DESTINY: {
			CLIENT: 1,
			DRIVER: 2,
			OWNER: 3,
			COMPANY: 4,
			DEDUCTION: 5,
		},
		TYPE: {
			IN: 1,
			OUT: 2,
		},
		STATUS: {
			PENDING: 0,
			PAID: 1,
		}
	},
	PER_PAGE: 20,
	PER_PAGE_WEB: 10,
	CURRENCY: {
		VED: 1,
		USD: 2,
	},
	TAXES: {
		IVA: 16,
		IGTF: 3,
	},
};
